import styled, { css, createGlobalStyle } from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const HostStyles = createGlobalStyle`
  :host {
    /* Colors */
    --date-picker-icon-color: var(--color-accent-foreground, #ffffff);
    --date-picker-background-color: var(--color-white, #ffffff);
    --date-picker-text-color: var(--color-typo, #0c2747);
    --date-picker-border-color: var(--color-accent-background, #395db8);
    --date-picker-error-color: var(--color-red, #f85454);

    /* Sizes */
    --date-picker-wrapper-padding: 0.5rem;
    --date-picker-text-size: 1.125rem;
    --date-picker-text-weight: 600;
    --date-picker-text-line-height: 1.75rem;
    --date-picker-border-radius: 0.5rem;
  }
`

const DatePicker = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  font-family: var(--font-body);
`

const Icon = styled(FontAwesomeIcon)`
  max-width: 14px;
  width: 100%;

  color: var(--date-picker-icon-color);
`

const CalendarIcon = styled(Icon)`
  max-height: 24px;

  margin-right: 12px;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 512px;
  max-width: 100%;

  background-color: var(--date-picker-background-color);

  padding: var(--date-picker-wrapper-padding);

  border: 1px solid var(--date-picker-border-color);

  border-radius: var(--date-picker-border-radius);

  cursor: pointer;

  @media (max-width: 820px) {
    width: 100%;
  }
`

const WrapperWithData = styled(Wrapper)`
  @media (max-width: 426px) {
    flex-direction: column;
    align-items: start;
  }
`

const Text = styled.div`
  font-size: var(--date-picker-text-size);
  line-height: var(--date-picker-text-line-height);
  font-weight: var(--date-picker-text-weight);

  color: var(--date-picker-text-color);
`

const ExpandedTitle = styled.span`
  @media (max-width: 426px) {
    display: none;
  }
`

const Location = styled(Text)`
  border-right: 1px solid var(--date-picker-border-color);
  padding-right: 12px;
  margin-right: 12px;

  @media (max-width: 426px) {
    border-right: 0px none;
    padding-right: 0px;
    margin-right: 0px;
  }
`

const Dates = styled(Text)`
  ${({ isValid }) => !isValid && css`
    color: var(--date-picker-error-color);
  `}

  @media (max-width: 426px) {
    font-weight: 400;
  }
`

DatePicker.Wrapper = Wrapper
DatePicker.WrapperWithData = WrapperWithData
DatePicker.CalendarIcon = CalendarIcon
DatePicker.Text = Text
DatePicker.ExpandedTitle = ExpandedTitle
DatePicker.Location = Location
DatePicker.Dates = Dates

export default DatePicker
